var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.18 6.71006L21.08 5.81006L22.18 3.41006L19.62 4.26006C18.8046 3.49999 17.7346 3.072 16.62 3.06006C14.137 3.06556 12.1255 5.07706 12.12 7.56006V8.56006C8.58 9.29006 5.49 7.36006 2.62 4.06006C2.12 6.72673 2.62 8.72673 4.12 10.0601L0.830002 9.56006C1.09233 11.746 2.88215 13.4306 5.08 13.5601L2.33 14.5601C3.33 16.5601 5.15 16.8701 7.58 17.0601C5.59382 18.4147 3.23357 19.1141 0.830002 19.0601C13.59 24.7301 21.08 16.4001 21.08 9.06006V8.23006L23.18 6.71006Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.87434980.svg";
export { ForwardRef as ReactComponent };